<template>
	<Card>
		<div class="yl-flex">
			<div class="yl-flex">
				<Input v-model="name" style="width: 250px" placeholder="请输入名称">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button style="margin-left: 10px;" type="primary" @click="search">搜索</Button>
				<Button style="margin-left: 10px;" @click="initSearch">重置</Button>
				<Button style="margin-left: 10px;" type="primary" @click="addPlatformCode">添加媒体代码</Button>
				<Button style="margin-left: 10px;" type="primary" @click="getMediaType">查看成本类型</Button>
			</div>
		</div>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data">
				<template slot-scope="{ row }" slot="action">
					<Button class='ivu-btn-circle' :data-id="row.id" @click="editPlatform" type="warning" size="small">
						编辑
					</Button>
					<Button class='ivu-btn-circle' :data-id="row.id" @click="delPlatform" style="margin-left: 10px"
						size="small">删除
					</Button>
				</template>
			</Table>
			<div class="pager">
				<Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-total
					show-elevator />
			</div>
		</div>
		<!-- 新增媒体代码 -->
		<Modal v-model="modal" width="700">
			<div class="add_flex">
				<div class="add_title">媒体平台</div>
				<Select v-model="mediaForm.medium_id" style="width:200px" placeholder="请选择媒体平台">
					<Option v-for="item in mediaList" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
				<div class="add_title">媒体代码</div>
				<Input v-model="mediaForm.name" style="width: 200px" placeholder="请输入媒体代码" />
			</div>
			<div class="add_flex">
				<div class="add_title">进线时间段选择</div>
				<TimePicker v-model="mediaForm.quantum" format="HH:mm" type="timerange" placement="bottom-end"
					style="width: 150px"></TimePicker>
				<div class="add_title">进线总数(天)</div>
				<Input v-model="mediaForm.day_limit" style="width: 100px" />
				<div class="add_title">进线开关</div>
				<Select v-model="mediaForm.is_open" style="width:100px">
					<Option v-for="item in coil_state_list" :value="item.value" :key="item.value">
						{{ item.label }}
					</Option>
				</Select>
			</div>
			<div class="add_flex">
				<div class="add_title">成本类型</div>
				<Select v-model="mediaForm.medium_code_type" style="width:100px">
					<Option v-for="item in mediaTypeData" :value="item.id" :key="item.media_type_name">
						{{ item.media_type_name }}
					</Option>
				</Select>
				<div class="add_title">老系统媒体id</div>
				<Select v-model="mediaForm.old_src_id" style="width:100px">
					<Option v-for="item in oldSrcIdList" :value="item.id" :key="item.id">{{item.username }}-[{{item.id}}]
						{{ item.media_type_name }}
					</Option>
				</Select>
			</div>
			<div class="add_flex">
				<div class="add_title">备注</div>
				<Input v-model="mediaForm.ext_info.remark" :rows="4" style="width: 600px" type="textarea" />
			</div>
			<div slot="footer">
				<Button type="primary" @click="save()">保存</Button>
			</div>
		</Modal>
		<!-- 新增媒体代码 -->
		<Modal v-model="mediaTypeModal" width="700">
			<div id="">
				<Button type="primary" @click="addMediaType()">添加成本类型</Button>
			</div>
			<Table :columns="medium_type_column" :data="mediaTypeData">
				<template slot-scope="{ row }" slot="action">
					<Button class='ivu-btn-circle' :data-id="row.id" @click="editMediaType" type="warning" size="small">
						编辑
					</Button>
					<Button class='ivu-btn-circle' :data-id="row.id" @click="delMediaType" style="margin-left: 10px"
						size="small">删除
					</Button>
				</template>
			</Table>
		</Modal>
		<Modal v-model="addMediaTypeModal" :styles="{top: '160px'}">
			<Form :model="MediaTypeFormItem" :label-width="80" style="margin-top: 30px;">
				<FormItem label="成本类型">
					<Input v-model="MediaTypeFormItem.media_type_name" placeholder="请输入成本类型名称"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="saveMediaType()">保存</Button>
			</div>
		</Modal>
	</Card>
</template>

<script>
	import {
		saveMediumCode,
		getMediumCodeList,
		getMediumCode,
		delMediumCode,
		getAllMedium,
		getMediumType,
		saveMediaType,
		getMediumTypeItem,
		delMediumCodeItem,
		getOldSystemSrcIdList
	} from '@/api/runSet'
	import {
		mapGetters,
		mapActions
	} from "vuex";

	export default {
		name: "media_code",
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		created() {
			this.loadData();
			this.getList();
		},
		data() {
			return {
				count: 0,
				page: 1,
				mediaForm: {
					medium_id: '',
					name: '',
					quantum: ['00:01', '23:59'],
					coil_total: '',
					day_limit: '',
					is_open: -1,
					medium_code_type: '',
					old_src_id:'',
					ext_info: {
						remark: ''
					}
				},
				coil_state_list: [{
						value: 1,
						label: '开'
					},
					{
						value: -1,
						label: '关'
					},
				],
				medium_type_list: [{
						value: 1,
						label: '推广1'
					},
					{
						value: 0,
						label: '正常'
					},
				],
				MediaTypeFormItem: {
					media_type_name: '',
				},
				mediaList: [],
				modal: false,
				mediaTypeModal: false,
				addMediaTypeModal: false,
				name: '',
				columns: [{
						title: 'ID',
						key: 'id'
					}, {
						title: '媒体平台',
						key: 'medium_name'
					},
					{
						title: '媒体代码',
						key: 'name'
					},
					{
						title: '备注',
						key: 'remark'
					},
					{
						title: '进线时间段',
						key: 'time_quantum'
					},
					{
						title: '进线总数(天)',
						key: 'day_limit'
					},
					{
						title: '成本类型',
						key: 'medium_code_type_name'
					},
					{
						title: '老系统id',
						key: 'old_src_id'
					},
					{
						title: '进线状态',
						key: 'is_open_name'
					},
					{
						title: '操作',
						slot: 'action'
					},
				],
				medium_type_column: [{
						title: 'ID',
						key: 'id',
						"align": "center",
					}, {
						title: '成本类型',
						key: 'media_type_name',
						"align": "center",
					},
					{
						title: '操作',
						slot: 'action',
						"align": "center",
					},
				],
				data: [],
				mediaTypeData: [],
				oldSrcIdList:[],
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			search() {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.name = '';
				this.page = 1;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {
					token: that.token
				};
				let res = await getAllMedium(that, data);
				if (res.code == 1) {
					this.mediaList = res.data.list;
				}
				res = await getMediumType(that, data);
				if (res.code == 1) {
					this.mediaTypeData = res.data.list;
				}
				res = await getOldSystemSrcIdList(that, data);
				that.oldSrcIdList = res.data.list;
			},
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					page: this.page,
					name: this.name
				};
				let res = await getMediumCodeList(that, data);
				if (res.code == 1) {
					that.data = res.data.list;
					that.count = res.count;
				}
			},
			// 新增媒体代码
			addPlatformCode() {
				this.initFormData();
				this.modal = true
			},
			getMediaType() {
				this.mediaTypeModal = true;
			},
			addMediaType() {
				this.addMediaTypeModal = true;
			},
			saveMediaType() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.MediaTypeFormItem
					};
					let res = await saveMediaType(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.addMediaTypeModal = false;
						res = await getMediumType(that, data);
						if (res.code == 1) {
							this.mediaTypeData = res.data.list;
						}
					}
				}, 500)
			},
			save() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.mediaForm
					};
					let res = await saveMediumCode(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.modal = false;
						that.initFormData();
						that.getList();
					}
				}, 500)
			},
			initFormData() {
				this.mediaForm = {
					medium_id: '',
					name: '',
					quantum: ['00:00', '23:59'],
					coil_total: '',
					day_limit: '1000',
					is_open: 1,
					ext_info: {
						remark: ''
					}
				};
			},
			async editMediaType(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id
				};
				let res = await getMediumTypeItem(that, data);
				if (res.code == 1) {
					that.MediaTypeFormItem = res.data.item;
					that.addMediaTypeModal = true;
				}
			},
			delMediaType(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delMediumCodeItem(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								res = await getMediumType(that, data);
								if (res.code == 1) {
									this.mediaTypeData = res.data.list;
								}
							}
						}, 1000);
					}
				})
			},
			async editPlatform(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id
				};
				let res = await getMediumCode(that, data);
				if (res.code == 1) {
					that.mediaForm = res.data.item;
					that.modal = true;
				}
			},
			delPlatform(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delMediumCode(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
	}

	.add_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.add_title {
		margin: 0 10px;
		font-weight: bold;

	}

	.add_box {
		border: 1px solid #969696;
		padding: 10px;
	}
</style>
